export enum QueryKey {
  Assessments = 'assessments',
  CalendarEvents = 'calendarEvents',
  Calendars = 'calendars',
  CalendarShareTokens = 'calendarShareTokens',
  Curriculums = 'curriculums',
  CurriculumsOrg = 'curriculumsOrg',
  DailyStaffHoursSummaryReport = 'dailyStaffHoursSummaryReport',
  DailyStudentHoursSummaryReport = 'dailyStudentHoursSummaryReport',
  DiscoveryTopics = 'discoveryTopics',
  DiscoveryTopicsOrg = 'discoveryTopicsOrg',
  DropOffSpaces = 'dropOffSpaces',
  EnrollmentCustomFields = 'enrollmentCustomFields',
  Enrollments = 'enrollments',
  Families = 'families',
  ExternalSponsors = 'externalSponsors',
  FamilyAttendees = 'familyAttendees',
  File = 'file',
  Groups = 'groups',
  Holidays = 'holidays',
  Upload = 'upload',
  GrowthIndicators = 'growthIndicators',
  LessonPlans = 'lessonPlans',
  LearningReports = 'learningReports',
  LearningSettings = 'learningSettings',
  Lessons = 'lessons',
  Members = 'members',
  MemberInfoChanges = 'memberInfoChanges',
  MemberPIN = 'memberPin',
  MemberPINReport = 'memberPinReport',
  Notifications = 'notifications',
  PayrollReport = 'payrollReport',
  PhotoLibrary = 'photoLibrary',
  Programs = 'programs',
  PublicCenterInfo = 'publicCenterInfo',
  PublicOrgInfo = 'publicOrgInfo',
  Routines = 'routines',
  Spaces = 'spaces',
  Staff = 'staff',
  StaffSignInDetailReport = 'staffSignInDetailReport',
  StudentInfoChanges = 'studentInfoChanges',
  StudentSignInDetailReport = 'studentSignInDetailReport',
  SubsidyClaimReport = 'subsidyClaimReport',
  SupportedVersions = 'supportedVersions',
  Tasks = 'tasks',
}
